import { SLOTS_APIS } from "@/api_framework/api_config";
import { IBookedSlotsDetailsResponse, IBookedSlotsDetailsResponseData } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useBookedSlotsDetailsAPI = () => {
  const [slotDetails, setSlotDetails] = useState<IBookedSlotsDetailsResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (slotId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(`${SLOTS_APIS?.BOOKED_SLOTS_DETAILS?.baseURL}${slotId}`, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBookedSlotsDetailsResponse>) => {
            if (res.data.status === true && res.data) {
              setSlotDetails(res.data.data);
            } else {
              setSlotDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            setSlotDetails(null);
            sendCurl(e.config["curlCommand"]);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { slotDetails, execute };
};
